import React from "react";
import { Tooltip, Box, Typography } from '@mui/material';
import { Groups } from '@mui/icons-material';

// Custom tooltip component for team collaboration
const CollaborationTooltip = ({ leadId, hasCollaboration, children, participants = [] }) => {
  const tooltipContent = hasCollaboration ? (
    <Box sx={{ p: 1, maxWidth: 250 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1.5 }}>
        <Groups sx={{ fontSize: 18,   color:"#050712", }} />
        <Typography 
          variant="subtitle2" 
          sx={{ 
            fontWeight: 'bold', 
            color:"#050712",
            textShadow: '0 1px 2px rgba(0,0,0,0.1)'
          }}
        >
          Team Collaboration
        </Typography>
      </Box>
      
      {participants.length > 0 ? (
        <>
          <Typography 
            variant="caption" 
            sx={{ 
              color: 'text.primary', 
              mb: 1, 
              display: 'block',
              fontWeight: 500,
              opacity: 0.9
            }}
          >
            Collaborating Team Members:
          </Typography>
          <Box sx={{ maxHeight: 120, overflow: 'auto' }}>
            {participants.map((name, index) => (
              <Box
                key={index}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  py: 0.5,
                  borderBottom: index < participants.length - 1 ? '1px solid' : 'none',
                  borderColor: 'divider'
                }}
              >
                <Box
                  sx={{
                    width: 6,
                    height: 6,
                    borderRadius: '50%',
                    backgroundColor: 'success.main',
                    mr: 1.5,
                    flexShrink: 0,
                    boxShadow: '0 1px 2px rgba(0,0,0,0.1)'
                  }}
                />
                <Typography 
                  variant="body2" 
                  sx={{ 
                    fontSize: '0.8rem',
                    color: 'text.primary',
                    fontWeight: 400
                  }}
                >
                  {name}
                </Typography>
              </Box>
            ))}
          </Box>
        </>
      ) : (
        <Typography 
          variant="body2" 
          sx={{ 
            color: 'text.secondary', 
            fontStyle: 'italic',
            opacity: 0.8
          }}
        >
          No other team members
        </Typography>
      )}
    </Box>
  ) : (
    <Box sx={{ p: 1 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Groups sx={{ fontSize: 18, color: 'grey.500' }} />
        <Typography 
          variant="subtitle2" 
          sx={{ 
            fontWeight: 'bold',
            color: 'text.primary'
          }}
        >
        Team Collaboration
        </Typography>
      </Box>
      {/* <Typography 
        variant="body2" 
        sx={{ 
          mt: 0.5, 
          color: 'text.secondary',
          opacity: 0.8
        }}
      >
        Click to add team members for collaboration
      </Typography> */}
    </Box>
  );

  return (
    <Tooltip
      title={tooltipContent}
      arrow
      placement="top"
      componentsProps={{
        tooltip: {
          sx: {
            bgcolor: 'background.paper',
            border: '1px solid',
            borderColor: 'divider',
            boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
            '& .MuiTooltip-arrow': {
              color: 'background.paper',
              '&:before': {
                border: '1px solid',
                borderColor: 'divider',
              }
            }
          }
        }
      }}
    >
      {children}
    </Tooltip>
  );
};

export default CollaborationTooltip;